export default __webpack_public_path__ + "static/Rhyme6-5c704395e350fcd681fa76adb5fc2c08.mp3";